const types = {
  object: { type: 'String', transform: JSON.stringify },
  number: { type: 'Float', transform: null },
  string: { type: 'String', transform: null }
}

const sorts = {
  reviews: {
    latest: { reviewDate: -1 },
    oldest: { reviewDate: 1 },
    top: { rating: -1, reviewDate: -1 }
  }
}

export { types, sorts }
